import React from "react";
import LoadSpinner from "../../common/spinner/loadSpinner";
import Menucustom from "../../common/menu/menucustom";


  export default class Contatti extends React.Component{
    constructor(props){
       super(props);
       this.state = {
         loading: true
       }
    }
    componentDidMount() {
     this.setState({loading: false});
    }
    render(){
     let content = this.state.loading ? <LoadSpinner/>:
 
     <div id="wrapper">
        <Menucustom/>
        <div className="container-fluid">
        <small
                style={{ fontSize: "14px" }}
                className="mb-2 text-gray-800"
              >
                Segnalazioni &#8594; Help Desk
              </small>
          <br/>
          <iframe src="http://35.205.186.202/helpdesk/hesk325" frameborder="10" height="94%" width="94%"/>
        </div>
      </div>
     return ( 
         <div>{content}</div>
     );
    }
 }

 